import { Box, Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Table, TableCaption, TableContainer, Tbody, Td, Th, Thead, Tr, useDisclosure, useToast } from '@chakra-ui/react'
import { deleteUser } from 'firebase/auth'
import { collection, deleteDoc, doc, getDoc, getDocs, orderBy, query, where } from 'firebase/firestore'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { db } from '../../../Configs/firebase'
import EditDataUser from '../../AppComponents/EditDataUser'
import TableUser from './TableAdmin/TableUser'

function AppBarUser() {

  const [userData, setUserData] = useState([])
  const [editDataUser, setEditDataUser] = useState(null)

  const toast = useToast()


  const EditDataComponent = async (id) => {
    console.log(id)
    const docRef = doc(db, "users", id);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      setEditDataUser(docSnap.data());
    } else {
      console.log("No such document!");
    }
  };


  const getDataUser = async () => {
    try {
      const ref = collection(db, "users")
        ;
      const q = query(ref,
        orderBy("update", "desc"));
      let result = [];
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        result.push(doc.data());
      });
      setUserData(result)
    } catch (error) {
      console.log(error)
    }
  }

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "users", id));
      toast({
        title: "Data Deleted",
        description: "",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
      getDataUser()
      deleteUser(id)
    } catch (error) {
      console.log(error)
    }
    getDataUser()
  }

  useEffect(() => {
    getDataUser()

    return () => {
      setUserData([])
    }
  }, [])


  return (
    <>
      <Box p="5">

        {editDataUser !== null && <EditDataUser editData={editDataUser} setEditData={setEditDataUser} data={getDataUser} />}
        {userData.length > 0 && (
          <TableUser data={userData} EditDataComponent={EditDataComponent} handleDelete={handleDelete} />
        )}
      </Box>
    </>
  )
}

export default AppBarUser